import * as Sentry from "shared/providers/sentry/sentry.package";

import { toast } from "shared/providers/toast/toast.package";
import { onError } from "shared/providers/apollo/link/error.package";

import { removeLocalStorageItem } from "shared/utils/local-storage";

import { WEB_AUTH_ADMIN_TOKEN } from "shared/common/data/constants";

import isInvalidSentryGqlCode from "shared/utils/is-invalid-sentry-gql-code";

const errorLink = (setIsMaintenance: (maintenance: boolean) => void) =>
  onError(({ graphQLErrors, networkError, operation, forward }) => {
    if (graphQLErrors) {
      for (let err of graphQLErrors) {
        const code =
          err.extensions &&
          err.extensions.code &&
          typeof err.extensions.code === "string"
            ? err.extensions.code
            : null;

        const isInvalidCode = isInvalidSentryGqlCode(code);

        if (!isInvalidCode) {
          Sentry.withScope((scope) => {
            scope.setTag("errorType", "graphql");
            scope.setContext("graphql", {
              operationName: operation.operationName,
              variables: operation.variables,
            });
            scope.setFingerprint([operation.operationName, err.message]);

            const transformedErr = new Error(err.message);

            transformedErr.name = `GraphQL Error: ${operation.operationName}`;

            Sentry.captureException(transformedErr);
          });
        }

        if (code === "UNAUTHENTICATED") {
          removeLocalStorageItem(WEB_AUTH_ADMIN_TOKEN);

          const queryString = window.location.search;
          let loginToken: string | null = null;

          if (queryString) {
            const urlParams = new URLSearchParams(queryString);
            loginToken = urlParams.get("loginToken");
          }

          if (loginToken) {
            window.location.replace(window.location.pathname);
          } else {
            window.location.reload();
          }
        }
      }
    } else if (networkError) {
      console.log(networkError);

      if ("statusCode" in networkError) {
        console.log("Status Code:", networkError.statusCode);
      }

      if (networkError.message.includes("Socket closed")) {
        toast.error(
          `An error occurred while establishing connection with socket. In-app notifications might not work. Error: ${networkError.message}`
        );
      }

      if (
        networkError.message.includes("Failed to fetch") ||
        networkError.message.includes("CORS") ||
        ("statusCode" in networkError && networkError.statusCode === 503)
      ) {
        setIsMaintenance(true);
      }
    }
  });

export default errorLink;
